var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSvg89(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 14,
    viewBox: "0 0 12 14",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.333008 5.87842C0.333008 2.81185 2.8956 0.333252 5.99531 0.333252C9.10375 0.333252 11.6663 2.81185 11.6663 5.87842C11.6663 7.42371 11.1043 8.85834 10.1793 10.0743C9.15888 11.4156 7.90111 12.5842 6.48537 13.5015C6.16135 13.7135 5.86892 13.7295 5.51331 13.5015C4.0895 12.5842 2.83173 11.4156 1.82001 10.0743C0.89433 8.85834 0.333008 7.42371 0.333008 5.87842ZM4.12917 6.05108C4.12917 7.07838 4.96745 7.88636 5.99531 7.88636C7.02384 7.88636 7.87019 7.07838 7.87019 6.05108C7.87019 5.03177 7.02384 4.18447 5.99531 4.18447C4.96745 4.18447 4.12917 5.03177 4.12917 6.05108Z",
    fill: "#7C7C7C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSvg89);
export default __webpack_public_path__ + "static/media/svg89.bcbdde87594a9676eeb31cd8cf0a1802.svg";
export { ForwardRef as ReactComponent };